exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.my-project-tasks-new .my-project-header-new{width:100%;height:52px;min-height:52px;display:flex;justify-content:space-between;align-items:flex-end;box-sizing:border-box;border-bottom:2px solid #8b8b8b}.my-project-tasks-new .my-project-header-new .project-name{margin-top:16px;margin-left:16px;height:36px;font-family:Oswald,sans-serif;font-size:24px;font-weight:300;text-align:left;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:#9b9b9b}.my-project-tasks-new .my-project-header-new .right-side{height:40px;margin-bottom:12px;margin-right:16px;display:flex;cursor:pointer;align-self:center}.my-project-tasks-new .my-project-header-new .right-side .contractor,.my-project-tasks-new .my-project-header-new .right-side .expandor{align-self:flex-end;width:16px;height:16px;background-size:16px 16px;background-repeat:no-repeat;cursor:pointer}.my-project-tasks-new .my-project-header-new .right-side .contractor{background-image:url(" + require("../../../../assets/images/contractor.svg") + ")}.my-project-tasks-new .my-project-header-new .right-side .expandor{background-image:url(" + require("../../../../assets/images/expandor.svg") + ")}.my-project-tasks-new .task-list{overflow:hidden;height:0}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/TasksContainer/NewProjectsTasksContainer/ProjectTasks/ProjectTasks.scss
// module id = 1851
// module chunks = 0